import React from "react";
import "./skill.css";
import { BsPatchCheckFill } from "react-icons/bs";

const Skill = () => {
  return (
    <section id="skill">
      <h5 className="skill__header">What Skills I Have</h5>
      <h2>Programming</h2>

      <div className="container skill__container">
        <div className="skill__desktop">
          <h3>Application Development</h3>
          <div className="skill__content">
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>C++</h4>
            </article>
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>Python</h4>
            </article>
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>Java</h4>
            </article>
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>C#</h4>
            </article>
          </div>
        </div>

        <div className="skill__web">
          <h3>Website and Mobile App Development</h3>
          <div className="skill__content">
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>React JS</h4>
            </article>
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>Express JS / Node JS</h4>
            </article>
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>React Native</h4>
            </article>
          </div>
        </div>
        <div className="skill__mobile">
          <h3>Others</h3>
          <div className="skill__content">
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>Computer Maintenance</h4>
            </article>
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>Networking</h4>
            </article>
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>Digital Marketing</h4>
            </article>
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>Graphis Design</h4>
            </article>
            <article className="skill__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <h4>Video Editing</h4>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skill;
